import { BusinessUnitKey } from '@/modules/bu/bu.types';
import routes from './routes/cleepo.routes';

// Discovered by the BU registry; see `src/modules/bu/registry.ts`.
export const key = BusinessUnitKey.Cleepo;
export default routes;
